




import Vue, { PropType } from "vue";
import { FieldDataItems } from "@/features/coreWebVitals/types";
import VueApexCharts from "vue-apexcharts";

export default Vue.extend({
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    fieldChartData: { type: Object as PropType<FieldDataItems> },
    labelList: { type: Array as PropType<Array<string | undefined>>, required: true },
    score: { type: String, required: true },
    fontColor: { type: String, required: true },
    isNoData: { type: Boolean, required: true },
    height: { type: Number, required: true },
  },
  data: () => ({
    series: {},
    options: {},
  }),
  created() {
    this.updateData();
  },
  methods: {
    updateData() {
      this.series = [
        {
          name: this.labelList[0],
          data: this.isNoData ? [75] : [this.fieldChartData.goodRate],
        },
        {
          name: this.labelList[1],
          data: this.isNoData ? [0] : [this.fieldChartData.needsImprovementRate],
        },
        {
          name: this.labelList[2],
          data: this.isNoData ? [25] : [this.fieldChartData.poorRate],
        },
      ];
      this.options = {
        chart: {
          type: "bar",
          stacked: true,
          stackType: "100%",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        colors: this.isNoData ? ["gray"] : ["#4CAF4F", "#ffba40", "#ff6c6b"],
        fill: {
          opacity: 1,
        },
        grid: {
          show: false,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "50%",
            borderRadius: 3,
          },
        },
        stroke: {
          show: false,
          width: 0,
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          show: false,
        },
        xaxis: {
          max: 100,
          tickAmount: 5,
          floating: false,
          axisBorder: {
            show: false,
          },
          labels: {
            formatter: function (value: number): string {
              return value + "%";
            },
          },
          crosshairs: {
            show: false,
          },
        },
        legend: {
          onItemClick: false,
          fontSize: "10px",
          offsetX: -8,
        },
        states: {
          hover: {
            filter: {
              type: "none",
            },
          },
          active: {
            filter: {
              type: "none",
            },
          },
        },
        tooltip: {
          enabled: !this.isNoData,
          x: {
            show: false,
          },
          y: {
            formatter: function (value: number) {
              return value + "%";
            },
          },
        },
        annotations: {
          position: "front",
          xaxis: [
            {
              x: 75,
              strokeDashArray: 0,
              borderColor: "gray",
              offsetY: -9,
              label: {
                borderColor: "#fff",
                borderRadius: 3,
                style: {
                  color: this.getFontColor(),
                  background: "#fff",
                  fontSize: "12px",
                },
                text: this.getContent(),
                orientation: "horizontal",
                offsetY: -4,
                cssClass: "apexcharts-xaxis-annotation-label",
              },
            },
          ],
        },
      };
    },
    getContent(): string {
      return this.isNoData ? "なし" : this.score;
    },
    getFontColor(): string {
      return this.isNoData ? "gray" : this.fontColor;
    },
  },
  watch: {
    fieldChartData() {
      this.updateData();
    },
  },
});
